import React from 'react';

const pillars = [
  {
    title: 'Community Connection',
    icon: 'bi-people-fill',
    copy: 'We aim to build strong bonds among our members, fostering friendships and support. Together, we create a welcoming space for all in Bothasig and beyond.',
  },
  {
    title: 'Knowledge Empowerment',
    icon: 'bi-book-fill',
    copy: 'Our madrasah and adult classes provide valuable learning experiences. We empower individuals with knowledge and skills to grow in faith and life. Join us!',
  },
  {
    title: 'Spiritual Enrichment',
    icon: 'bi-moon-stars-fill',
    copy: 'Through our Thikr nights and hifth programs, we nourish the soul and deepen connections with Allah. Experience spiritual growth and community together.',
  },
];

const MissionSection: React.FC = () => {
  return (
    <section id="mission" className="mission-section">
      <div className="container py-5">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <span className="section-eyebrow section-eyebrow--light">Our Guiding Mission</span>
            <h2 className="section-title section-title--light mt-2">Three pillars that guide everything we do</h2>
          </div>
        </div>
        <div className="row g-4">
          {pillars.map((pillar, index) => (
            <div key={pillar.title} className="col-12 col-md-6 col-lg-4">
              <div className="mission-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="mission-card-icon">
                  <i className={`bi ${pillar.icon}`}></i>
                </div>
                <h3 className="mission-card-title">{pillar.title}</h3>
                <p className="mission-card-copy mb-0">{pillar.copy}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
